import * as tslib_1 from "tslib";
import { Base } from '../base-component';
import { AnalyticsService } from '../../services/analytics.service';
import axios from 'axios';
import './form-item-nigeria-account-enquiry.component.scss';
import * as $ from 'jquery';
var FormItemNigeriaAccountEnquiry = /** @class */ (function (_super) {
    tslib_1.__extends(FormItemNigeriaAccountEnquiry, _super);
    function FormItemNigeriaAccountEnquiry(element) {
        var _this = _super.call(this, element) || this;
        // values
        _this.valuesJson = {};
        return _this;
    }
    FormItemNigeriaAccountEnquiry.prototype.init = function () {
        this.form = this.element.querySelector('form');
        this.selectTitle = this.element.querySelector('.js-title');
        this.buttonSubmit = Array.from(this.element.querySelectorAll('.js-apply-now__button'));
    };
    FormItemNigeriaAccountEnquiry.prototype.bindEvents = function () {
        var _this = this;
        this.selectTitle.addEventListener('change', function (event) {
            var element = event.target;
            _this.addMoreTitle(element);
        });
        this.buttonSubmit.map(function (item) { return item.addEventListener('click', function (event) {
            var formFields = _this.form.querySelectorAll('input, select, textarea');
            var validation = _this.validationService.validate(formFields);
            var valid = Array.from(_this.form.querySelectorAll(".form__group--error"));
            if (valid.length == 0) {
                if (_this.valuesJson.feedbackType !== "") {
                    _this.actionForm(_this.form, _this.element.querySelector('.form__loader--container'), _this.element.querySelector('.form__thankyou--container'));
                }
                else {
                    _this.radioFeedbackType.map(function (item, index) {
                        var parent = item.closest('.form__group');
                        parent.classList.add('form__group--error');
                    });
                }
            }
        }); });
        $(document).on('click', '.js-apply-now-modal-open', function (event) {
            var element = event.target;
            var modal = $(element).attr('data-modal');
            if (modal) {
                _this.callmebackFormId = modal;
            }
        });
    };
    FormItemNigeriaAccountEnquiry.prototype.addMoreTitle = function (element) {
        if (element) {
            if (element.value == 'Other') {
                var parentParent = element.closest('.form__fields--container');
                var parent_1 = element.closest('.form__group');
                var newContainer = document.createElement('div');
                newContainer.classList.add('form__group');
                newContainer.classList.add('js-other-title-container');
                var newLabel = document.createElement('label');
                newLabel.classList.add('form__label');
                newLabel.innerHTML = 'Other Title';
                newContainer.appendChild(newLabel);
                var newInput = document.createElement('input');
                newInput.classList.add('js-other-title');
                newInput.classList.add('form__input');
                newInput.classList.add('form__input--required');
                newInput.setAttribute('placeholder', 'Enter your title');
                newInput.setAttribute('maxlength', '4');
                newInput.setAttribute('name', 'other-title');
                newContainer.appendChild(newInput);
                parentParent.insertBefore(newContainer, parent_1.nextSibling);
            }
            else {
                var parentParent = element.closest('.form__fields--container');
                var oldInput = this.element.querySelector('.js-other-title-container');
                if (oldInput) {
                    parentParent.removeChild(oldInput);
                }
            }
        }
    };
    FormItemNigeriaAccountEnquiry.prototype.resetForm = function () {
        if (this.form) {
            this.form.reset();
            var formContainerLoader = this.element.querySelector('.form__loader--container');
            var formContainerFields = this.element.querySelector('.form__fields--container');
            var formContainerThankyou = this.element.querySelector('.form__thankyou--container');
            formContainerThankyou.classList.remove('active');
            formContainerFields.classList.remove('hidden');
        }
    };
    FormItemNigeriaAccountEnquiry.prototype.actionForm = function (form, loader, thankyou) {
        // fields
        var recipient = this.form.querySelector('input[name=recipient]');
        var email = this.form.querySelector('input[name=email]');
        var subject = this.form.querySelector('input[name=subject]');
        var redirect = this.form.querySelector('input[name=redirect]');
        var product = this.form.querySelector('input[name=product]');
        var title = this.form.querySelector('select[name=title]');
        var titleOther = form.querySelector('input[name=other-title]');
        var firstName = form.querySelector('input[name=first-name]');
        var surname = form.querySelector('input[name=surname');
        var telephone = form.querySelector('input[name=telephone-number');
        var emailAddress = form.querySelector('input[name=emailAddress');
        var comments = form.querySelector('textarea[name=comments');
        var pageUrl = window.location.href;
        var postData = '';
        if (recipient) {
            postData += 'recipient=' + recipient.value + '&';
        }
        if (email) {
            postData += 'email=' + email.value + '&';
        }
        if (subject) {
            postData += 'subject=' + subject.value + '&';
        }
        if (redirect) {
            postData += 'redirect=' + redirect.value + '&';
        }
        if (product) {
            postData += 'productName=' + product.value + '&';
        }
        if (title) {
            if (titleOther) {
                postData += 'title=' + titleOther.value + '&';
            }
            else {
                postData += 'title=' + title.value + '&';
            }
        }
        if (firstName) {
            postData += 'firstName=' + firstName.value + '&';
        }
        if (surname) {
            postData += 'surname=' + surname.value + '&';
        }
        if (telephone) {
            postData += 'tel=' + telephone.value + '&';
        }
        if (emailAddress) {
            postData += 'emailAddress=' + emailAddress.value + '&';
        }
        if (comments) {
            postData += 'comments=' + comments.value + '&';
        }
        if (this.callmebackFormId) {
            postData += 'callmebackFormId=' + this.callmebackFormId + '&';
        }
        if (pageUrl) {
            postData += 'pageUrl=' + pageUrl + '&';
        }
        // loader + hide form
        var fieldsContainer = form.querySelector('.form__fields--container');
        loader.classList.add('active');
        fieldsContainer.classList.add('hidden');
        // variables
        var analyticsService = new AnalyticsService();
        var url = "/services/SubmitGenericForm.jsp";
        var config = {
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8',
                "Access-Control-Allow-Origin": "*",
                'X-Requested-With': 'XMLHttpRequest'
            }
        };
        // service
        axios.post(url, postData, config).then(function (response) {
            // service ok
            loader.classList.remove('active');
            analyticsService.dtmFormComplete('complete', '');
            loader.classList.remove('active');
            thankyou.classList.add('active');
        }).catch(function (response) {
            // service failed
            analyticsService.dtmFormComplete('complete', '');
            loader.classList.remove('active');
            thankyou.classList.add('active');
        });
    };
    return FormItemNigeriaAccountEnquiry;
}(Base));
export { FormItemNigeriaAccountEnquiry };



//////////////////
// WEBPACK FOOTER
// ./components/form-item-nigeria-account-enquiry/form-item-nigeria-account-enquiry.component.ts
// module id = 329
// module chunks = 0